import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import * as S from './styles';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { ReactComponent as FacebookSpecificsIcon } from 'common/images/icon-facebook-specifics.svg'
import { Loader } from 'components/Loader'
import { serviceLoading } from 'common/loaderReducer';
import { GET_DEALERINFO_API_REQUEST } from 'features/Dealers/Listings/Info/state/actionTypes';
import { POST_DEALERLM_API_REQUEST } from 'features/Dealers/Listings/Data/state/actionTypes';
import { editLiveDealerLMInfo, postDealerLMAPI } from 'features/Dealers/Listings/Data/state/actions';
import { getSyncError, phoneFormat } from 'features/Dealers/Listings/utils';
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';
import ViewImage from '../Images/ViewImage';
import { TCButton } from "components/TCButton";
import { TC_BUTTON_TYPE } from "components/TCButton/constants";
import { IMAGE_PICKER_TRIGGER } from 'features/Dealers/Listings/Images/utils';
import { LMconfig, photoSpecifics } from 'features/Dealers/Listings/Data/state/types';
import { MediaGallery } from 'components/MediaGallery';
import { LMUrldata } from 'features/Dealers/Listings/Images/state/types';
import UploadIcon from 'common/icons/uploadIcon';
import RemoveIcon from 'common/icons/removeIcon';
import ToolTip , { ToolTipDirection } from 'components/ToolTip';
import { MEDIA_ACTION, MEDIA_URL_TYPE } from 'features/Dealers/Listings/Images/state/constants'


const FacebookSpecifics = (props: any) => {
    const [saving, setSaving] = React.useState(false);
    const [firstLoad, setFirstLoad] = React.useState(true);
    const [editingState, setEditingState] = React.useState(InputIconFieldState.VIEW);
    const dispatch = useDispatch();
    const [shouldRenderImagePicker, setShouldRenderImagePicker] = React.useState(IMAGE_PICKER_TRIGGER.NONE);

    const {
        validation,
        isLoading,
        isSaving,
        live,
        listingSyncErrors,
        selectedListingId,
        selectedDealerId,
        selectedDealer,
        originalLMDealerInfo, 
        originalimages,
        aboutMinCharacters,
        aboutMaxCharacters
    } = useSelector((rootState: RootState) => {
        return {
            validation: rootState.dealers.listing.currentListing.data.validation,
            isLoading: serviceLoading(rootState, [GET_DEALERINFO_API_REQUEST]),
            isSaving: serviceLoading(rootState, [POST_DEALERLM_API_REQUEST]),
            live: rootState.dealers.listing.currentListing.data.liveDealerLMInfo,
            originalLMDealerInfo: rootState.dealers.listing.currentListing.data.dealerLMInfo,
            listingSyncErrors: rootState.dealers.listing.listings.listingSyncErrors,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            originalimages: rootState.dealers.listing.currentListing.images.dealerImages,
            aboutMinCharacters: rootState.dealers.listing.listings.lmValidation?.aboutValidation?.minCharacters,
            aboutMaxCharacters: rootState.dealers.listing.listings.lmValidation?.aboutValidation?.maxCharacters
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (!firstLoad && !isSaving && selectedListingId && selectedListingId != "" && selectedDealerId) {
            setSaving(false);
            dispatch(getListingSyncErrors(selectedListingId??""));
            dispatch(getDealerListingsWithErrors(selectedDealerId??""));
        }
        setFirstLoad(false);
    }, [isSaving])

    React.useEffect(() => {
        let valid = true;
        if (validation && !validation.allDataValid && validation.dataValidation) {
            if(validation.dataValidation.fbCoverImageValidation && !validation.dataValidation.fbCoverImageValidation.imageValidOrFixed)
            {
                valid = false;
                const imageWithValidation: photoSpecifics = {
                    url: live?.customPhotoURL.url??"", 
                    validation: validation.dataValidation.fbCoverImageValidation.imageValidation?.errorMessages??[]
                }
                let newLiveData: LMconfig = {...live!, customPhotoURL: imageWithValidation};
                dispatch(editLiveDealerLMInfo(newLiveData))
            } 
        }
        if (valid) {
            setEditingState(InputIconFieldState.VIEW)
        }
        else {
            setEditingState(InputIconFieldState.EDIT)
        }
        setFirstLoad(false);
    }, [validation]) 

    if (isLoading || !selectedListingId || selectedListingId == "") {
        return (
                <Loader/>
        )
    } else {
        return (
            <S.SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Facebook Custom Fields'}
                    state={saving ? InputIconFieldState.LOADING : editingState}
                    renderValue={renderFacebookSpecifics}
                    renderIcon={() => { return (<S.IconContainer><FacebookSpecificsIcon /></S.IconContainer>) }}
                    showAlertIcon={getSyncError('facebookSpecifics',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('facebookSpecifics',listingSyncErrors)}
                    showEditErrorMessage={getSyncError('facebookSpecifics',listingSyncErrors)?true:false}
                    editErrorMessage={getSyncError('facebookSpecifics',listingSyncErrors)}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action) }}
                    disableSave={getDisabled()}
                    disableBackground={true}
                    showCharacterCount={true}
                    showCharacterLimit={true}
                    minCharacters={aboutMinCharacters}
                    maxCharacters={aboutMaxCharacters}
                    characterCount={getCharacterCount('about')}
                />
            </S.SectionWrapper>
        )
    }

    function getDisabled(): boolean {
        if (live?.about!==null) return false;
        if ((live?.customPhoneNumber!==null && live?.customPhoneNumber!=="") || (live?.customURL!==null && live?.customURL!=="")) return false;
        return true;
    }

    function getCharacterCount(field: string):number {
        if (live && live[field]) {
            return live[field].toString().length;
        }
        return 0;
    }

    function onFieldActionClick(action: InputIconFieldAction) {
        switch (action) {
            case InputIconFieldAction.SAVE:
                {
                    setSaving(true);
                    if (live) {
                        if (live.customPhoneNumber) live.customPhoneNumber = live.customPhoneNumber.replace(/\D/g, '');
                        dispatch(postDealerLMAPI(selectedListingId ?? "", "facebookSpecifics", live))
                    }
                    break;
                }
            case InputIconFieldAction.EDIT:
                {
                    setEditingState(InputIconFieldState.EDIT)
                    break;
                }
            case InputIconFieldAction.CANCEL:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    dispatch(editLiveDealerLMInfo(originalLMDealerInfo))
                }
        }
    }

    function renderFacebookSpecifics() {
        let info: any = undefined;
        if (editingState === InputIconFieldState.VIEW || editingState === InputIconFieldState.LOADING) {
            if (live) {
                return ( <>
                            <S.Row>
                                <S.Label>Custom Phone Number</S.Label>
                                <S.Label>Custom URL</S.Label>
                            </S.Row>
                            
                            {((!live.customPhoneNumber || live.customPhoneNumber==="") && (!live.customURL || live.customURL===""))
                            ?<S.Row><S.EmptyText>Click edit to add information to these fields</S.EmptyText></S.Row>
                            :<S.Row flexFlow='wrap'>
                                <S.ViewLabelNumber> {phoneFormat(live.customPhoneNumber??"")} </S.ViewLabelNumber> 
                                <S.ViewLabelUrl>{live.customURL??''}</S.ViewLabelUrl>
                            </S.Row>}
                            
                            <S.Label marginTop={"17px"}>Cover Photo</S.Label>
                            {
                                renderMessage('COVERFACEBOOK')
                            }
                            {(!live.customPhotoURL || !live.customPhotoURL.url || live.customPhotoURL.url==="")
                            ?<S.Row><S.EmptyText>Upload a photo to view preview here</S.EmptyText></S.Row>
                            :<>
                            <ViewImage urlImage={finalUrl(live.customPhotoURL.url)}></ViewImage>
                            </>}

                            <S.Label marginTop={"31px"}>About</S.Label>
                            {(!live.about || live.about==="")
                            ?<S.Row><S.EmptyText>Click edit to add custom description here</S.EmptyText></S.Row>
                            :<S.ViewLabel>{live.about??''}</S.ViewLabel>}
                        </>)
            }
        } else if (editingState === InputIconFieldState.EDIT && live) {;
            return ( <>
                        <>
                            <S.Row>
                                <S.Label>Custom Phone Number</S.Label>
                                <S.Label>Custom URL</S.Label>
                            </S.Row>

                            <S.Row>
                                <S.Input
                                    value={phoneFormat(live.customPhoneNumber??"")}
                                    onChange={(e) => onFacebookChange('customPhoneNumber', `${e.target.value}`)}
                                />
                                <S.Input
                                value={live.customURL??''}
                                onChange={(e) => onFacebookChange('customURL', `${e.target.value}`)}
                                />
                            </S.Row>

                            <S.Label marginTop={"17px"}>Cover Photo</S.Label>
                            {
                                renderMessage('COVERFACEBOOK')
                            }
                            {
                                (live.customPhotoURL !== undefined && live.customPhotoURL.url !== undefined && live.customPhotoURL.url !== "")
                                ?
                                renderFacebookPhoto(live.customPhotoURL)
                                :
                                <S.AddMore onClick={() => setShouldRenderImagePicker(IMAGE_PICKER_TRIGGER.FACEBOOKPHOTO)}>
                                    {
                                        "Add photo"
                                    }
                                </S.AddMore>
                            }

                            <S.Label marginTop={"16px"}>About</S.Label>
                            <S.InputTextarea
                                value={live?.about}
                                onChange={(e) => (!aboutMaxCharacters || e.target.value.length<=aboutMaxCharacters) ? (onFacebookChange('about', e.target.value)) : (onFacebookChange('about', e.target.value.substring(0,aboutMaxCharacters)))}
                            />
                        </>
                        <>
                            {
                                selectedDealer && selectedDealerId && shouldRenderImagePicker !== IMAGE_PICKER_TRIGGER.NONE &&
                                <MediaGallery
                                    dealerId={selectedDealerId}
                                    dealerURL={selectedDealer.url??""}

                                    onMediaGalleryClose={onMediaGalleryClose}
                                />
                            }
                        </>

                    </>
                    
            );
        }
    }

    function onFacebookChange(field: string, value: string) {
        if (live) {
            if (field==="customPhoneNumber") value = phoneFormat(value).replace(/[^0-9]/g,'');
            dispatch(editLiveDealerLMInfo({ ...live, [field]: value ?? "" }))
        }
    }

    function isInCloudStorage(url: string): boolean {
        if (url.toLowerCase().includes("lismacloudstorage")){
            return true;
        }
        return false;
    }

    function GetExtension(name: string): string
    {
        let filename: string = name;
        //to remove the domain
        if (name.lastIndexOf("/") != -1 && name.lastIndexOf("/") + 1 < name.length)
        {
            filename = name.substring(name.lastIndexOf("/") + 1);
        }
        if (filename.indexOf(".") == -1 || filename.lastIndexOf(".") == filename.length - 1)
        {
            return "";
        }
        return filename.substring(filename.lastIndexOf(".") + 1);
    }

    function RemoveExtension(name: string): string {
        const extension:string = GetExtension(name);
        if (extension === undefined || extension === "")
        {
            return name;
        }
        return name.substring(0, name.lastIndexOf("." + extension));
    }

    function finalUrl(url: string): string {
        if (isInCloudStorage(url)) {
            return RemoveExtension(url) + "_thumbnail.jpg";
        }
        return url;
    }

    function onImageRemoveClick() {
        const removeImage: photoSpecifics = {
            url: '', 
            validation: []
        }
        let newLiveData: LMconfig = {...live!, customPhotoURL: removeImage};
        dispatch(editLiveDealerLMInfo(newLiveData))
    }

    function renderFacebookPhoto(photoURL: photoSpecifics) {
        return (
            <S.ColumnFacebookPhoto>
            <S.RowFacebookPhoto>
                <S.ImageBox>
                    <S.ImageContainer>
                        <S.Image src={finalUrl(photoURL.url)} />
                    </S.ImageContainer>
                </S.ImageBox>
                <S.Row>
                    <S.ActionContainer onClick={(event) => onImageRemoveClick()}>
                        <RemoveIcon>
                        </RemoveIcon>                   
                    </S.ActionContainer>
                    <S.ActionContainer onClick={(event) =>  { setShouldRenderImagePicker(IMAGE_PICKER_TRIGGER.FACEBOOKPHOTO) }}>                 
                        <UploadIcon></UploadIcon>
                    </S.ActionContainer>
                </S.Row>
            </S.RowFacebookPhoto>
            <S.RowFacebookPhoto>
                {
                    photoURL.validation && photoURL.validation.length>0 &&
                    renderImageError(photoURL.validation)
                }
            </S.RowFacebookPhoto>
            </S.ColumnFacebookPhoto>
        )
    }

    function renderImageError(validationErrors: string[])
    {
        return (
            <S.ImageErrorContainer>
                <S.ColumnFacebookPhoto>
                    This image has the following errors:
                    <S.ImageErrorList>
                        {
                            validationErrors.map((error) => { return <li>{error}</li> })
                        }
                    </S.ImageErrorList>
                    Please select a different image.
                </S.ColumnFacebookPhoto>
            </S.ImageErrorContainer>
        )
    }

    function onMediaGalleryClose(imgUrls: string[]) {
        
        if (imgUrls && imgUrls.length > 0) {
            const newUrl: LMUrldata = {
                type: MEDIA_URL_TYPE.ORIGIN,
                url: imgUrls[0]
            }
            let urls: LMUrldata[] = [];
            urls.push(newUrl);

            const newImage: photoSpecifics = {
                url: urls[0].url, 
                validation: []
            }
            let newLiveData: LMconfig = {...live!, customPhotoURL: newImage};
            dispatch(editLiveDealerLMInfo(newLiveData))
        }
        setShouldRenderImagePicker(IMAGE_PICKER_TRIGGER.NONE)
    }

    function renderMessage(category: string) {
        return (
            <S.Information>
            {
                originalimages?.informationMessages.find((message) => { return message.category==category})?.message
            }
            </S.Information>
        )
    }
}

export default FacebookSpecifics;